module.exports = __webpack_public_path__ + "static/img/6.b3c42a8b.svg";